import { factoryPermission } from "@/models";

export const WeighingPermission = {
  REVIEW: factoryPermission("Weighing.Web.ReviewItemMenu"),
  REVIEW_DGRECI: factoryPermission("Weighing.Web.Review.DGRECI"),
  REVIEW_CV_COORDINATOR: factoryPermission("Weighing.Web.Review.Coordinator"),
  PRODUCTIVITY: factoryPermission("Weighing.Web.ProductivityFullAccess"),
  DETAILED_PRODUCTIVITY: factoryPermission("Weighing.Web.DetailedProductivityFullAccess"),
};
